export default "__VITE_ASSET__895b893d__"